// extracted by mini-css-extract-plugin
export default {"header":"Header_header__Lhnr8","title":"Header_title__rzFD1","subtitle":"Header_subtitle__iGGQD"};